// @ts-nocheck

class RelatedProductGrid {
  constructor() {
    this.sectionEl = document.querySelector('[data-rpg]');
    if (!this.sectionEl) return;

    this.gridEl = this.sectionEl.querySelector('[data-rpg-grid]');
    this.baseUrl = this.sectionEl.dataset.rpgUrl;
    this.sectionId = this.sectionEl.dataset.rpgSectionId;
    this.productId = this.sectionEl.dataset.rpgProductId;
    this.limit = this.sectionEl.dataset.rpgLimit;
    if (!this.gridEl || !this.baseUrl || !this.sectionId || !this.productId) return;

    this.swat = null;
    this.gridReady = false;
    this.userInteracted = false;
    this.syncTimer = null;
    this.syncTimerLate = null;
    this.setupWishlistClicks();
    this.captureSwat();
    this.getRecommendations();
  }

  setupWishlistClicks() {
    document.addEventListener(
      'pointerdown',
      (event) => {
        const btn = event.target.closest && event.target.closest('.rpg__wishlist');
        if (!btn || !this.gridEl.contains(btn)) return;
        this.userInteracted = true;
        btn.classList.toggle('is-wishlisted');
        this.scheduleSync();
      },
      true
    );
  }

  scheduleSync() {
    clearTimeout(this.syncTimer);
    clearTimeout(this.syncTimerLate);
    this.syncTimer = setTimeout(() => this.reconcile(), 900);
    this.syncTimerLate = setTimeout(() => this.reconcile(), 2200);
  }

  captureSwat() {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push((swat) => {
      this.swat = swat;
      document.addEventListener('swym:collections-loaded', () => {
        this.initWishlistButtons();
        this.seedInitialState();
      });
      this.bindWishlistEvents();
      this.initWishlistButtons();
      this.seedInitialState();
    });
  }

  bindWishlistEvents() {
    if (!this.swat || !this.swat.evtLayer) return;
    if (typeof this.swat.evtLayer.addEventListener !== 'function') return;
    this.swat.evtLayer.addEventListener('sw:addedtowishlist', () => this.scheduleSync());
    this.swat.evtLayer.addEventListener('sw:removedfromwishlist', () => this.scheduleSync());
  }

  getRecommendations() {
    const url = `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=related`;
    fetch(url)
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => this.render(html))
      .catch(() => this.hide());
  }

  render(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fetchedGrid = parsed.querySelector('[data-rpg-grid]');
    if (!fetchedGrid || !fetchedGrid.children.length) {
      this.hide();
      return;
    }
    this.gridEl.style.cssText = fetchedGrid.style.cssText;
    this.gridEl.innerHTML = fetchedGrid.innerHTML;
    this.sectionEl.hidden = false;
    this.gridReady = true;
    this.initWishlistButtons();
    this.seedInitialState();
    setTimeout(() => this.seedInitialState(), 800);
    setTimeout(() => this.seedInitialState(), 2000);
  }

  initWishlistButtons() {
    if (!this.swat || !this.gridReady) return;
    if (typeof this.swat.initializeActionButtons !== 'function') return;
    try {
      this.swat.initializeActionButtons('.rpg__grid');
    } catch (error) {
      // Swym build differs — buttons remain unbound.
    }
  }

  seedInitialState() {
    if (this.userInteracted) return;
    this.reconcile();
  }

  reconcile() {
    if (!this.swat || !this.gridReady) return;
    if (typeof this.swat.fetchWrtEventTypeET !== 'function') return;
    const eventType = this.swat.EventTypes && this.swat.EventTypes.addToWishList;
    try {
      this.swat.fetchWrtEventTypeET((products) => {
        if (!Array.isArray(products)) return;
        const ids = new Set(products.map((item) => String(item.empi)));
        this.gridEl.querySelectorAll('.rpg__wishlist').forEach((btn) => {
          btn.classList.toggle('is-wishlisted', ids.has(String(btn.dataset.productId)));
        });
      }, eventType);
    } catch (error) {
      // Swym fetch API unavailable — leave hearts as the optimistic click state.
    }
  }

  hide() {
    this.sectionEl.hidden = true;
  }
}

new RelatedProductGrid();
